import { render, staticRenderFns } from "./header-credits-component.vue?vue&type=template&id=76943c19"
import script from "./header-credits-component.vue?vue&type=script&lang=js"
export * from "./header-credits-component.vue?vue&type=script&lang=js"
import style0 from "./header-credits-component.vue?vue&type=style&index=0&id=76943c19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports